import { Flex, ListItem, OrderedList, Text } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { InvitationRead } from "@nens/rana/api-v1";
import { RanaLoading, RanaModal } from "@nens/ranalib";

import { cancelButtonText } from "@/translations";

import { useRevokeUserInvites } from "../api/revoke-user-invite";

interface RevokeInviteModalProps {
  invitations: InvitationRead[];
  onClose: () => void;
}

export function RevokeInviteModal({ invitations, onClose }: RevokeInviteModalProps) {
  const intl = useIntl();

  const { mutateAsync: revokeInvitation, isMutating } = useRevokeUserInvites();

  const deleteFilesOrDirectories = async () => {
    await revokeInvitation({ invitations });
    onClose();
  };

  const title = intl.formatMessage({
    id: "header.revoke_invites",
    defaultMessage: "Revoke invites",
  });

  return (
    <RanaModal
      isOpen
      onClose={onClose}
      topBar={title}
      maxW="xl"
      h="fit"
      buttons={[
        {
          children: cancelButtonText,
          variant: "tertiary",
          isDisabled: isMutating,
          onClick: onClose,
        },
        {
          children: title,
          variant: "danger",
          isDisabled: isMutating,
          onClick: deleteFilesOrDirectories,
        },
      ]}
    >
      <Flex flexDir="column" gap={2}>
        <Text>
          <FormattedMessage
            id="message.do_you_want_to_revoke_invites"
            defaultMessage="Do you really want to revoke the invites for:"
          />
        </Text>
        <OrderedList>
          {invitations.map(({ id, email }) => (
            <ListItem key={id}>
              <Flex alignItems="center">{email}</Flex>
            </ListItem>
          ))}
        </OrderedList>
        {isMutating && <RanaLoading size="md" isCentered />}
      </Flex>
    </RanaModal>
  );
}
